// import React, { useState, useEffect, useRef } from "react";
// import HeroTextOverlay from './HeroTextOverlay';
// import './FullWidth3DSlider.css';

// // Import all header_main images
// import header1 from '../../images/header_main/1.jpeg';
// import header2 from '../../images/header_main/2.jpeg';
// import header3 from '../../images/header_main/3.jpeg';
// import header4 from '../../images/header_main/4.jpeg';
// import header5 from '../../images/header_main/5.jpeg';
// import header6 from '../../images/header_main/6.jpeg';
// import header7 from '../../images/header_main/7.jpeg';
// import header8 from '../../images/header_main/8.jpeg';
// import header9 from '../../images/header_main/9.jpeg';
// import header10 from '../../images/header_main/10.jpeg';
// import header11 from '../../images/header_main/11.jpeg';
// import header12 from '../../images/header_main/12.jpeg';
// import header13 from '../../images/header_main/13.jpeg';
// import header14 from '../../images/header_main/14.jpeg';
// import header15 from '../../images/header_main/15.jpeg';
// import header16 from '../../images/header_main/16.jpeg';
// import header17 from '../../images/header_main/17.jpeg';
// import header18 from '../../images/header_main/18.jpeg';
// import header19 from '../../images/header_main/19.jpeg';
// import header20 from '../../images/header_main/20.jpeg';
// import header21 from '../../images/header_main/21.jpeg';
// import header22 from '../../images/header_main/22.jpeg';
// import header23 from '../../images/header_main/23.jpeg';
// import header24 from '../../images/header_main/24.jpeg';
// import header25 from '../../images/header_main/25.jpeg';
// import header26 from '../../images/header_main/26.jpeg';
// import header27 from '../../images/header_main/27.jpeg';
// import header28 from '../../images/header_main/28.jpeg';
// import header29 from '../../images/header_main/29.jpeg';
// import header30 from '../../images/header_main/30.jpeg';
// import header31 from '../../images/header_main/31.jpeg';
// import header32 from '../../images/header_main/32.jpeg';
// import header33 from '../../images/header_main/33.jpeg';
// import header34 from '../../images/header_main/34.jpeg';
// import header35 from '../../images/header_main/35.jpeg';
// import header36 from '../../images/header_main/36.jpeg';
// import header37 from '../../images/header_main/37.jpeg';
// import header38 from '../../images/header_main/38.jpg';
// import header39 from '../../images/header_main/39.jpg';
// import header40 from '../../images/header_main/40.jpg';
// import header41 from '../../images/header_main/41.jpg';
// import header42 from '../../images/header_main/42.jpg';

// const FullWidth3DSlider = () => {
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);
//     const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
//     const sliderRef = useRef(null);

//     const headerImages = [
//         header34, header35, header36, header37, header38, header39, header40, header41, header42
//     ];

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentImageIndex(prevIndex =>
//                 prevIndex === headerImages.length - 1 ? 0 : prevIndex + 1
//             );
//         }, 3000); // Change image every 3 seconds

//         return () => clearInterval(interval);
//     }, [headerImages.length]);

//     const handleMouseMove = (e) => {
//         if (sliderRef.current) {
//             const rect = sliderRef.current.getBoundingClientRect();
//             const x = (e.clientX - rect.left) / rect.width;
//             const y = (e.clientY - rect.top) / rect.height;
//             setMousePosition({ x, y });
//         }
//     };

//     return (
//         <section
//             className="full-width-3d-slider"
//             ref={sliderRef}
//             onMouseMove={handleMouseMove}
//         >
//             {/* Background Video Effect */}
//             <div className="slider-background">
//                 <div className="background-particles"></div>
//                 <div className="background-grid"></div>
//             </div>

//             {/* Main Slider Container */}
//             <div className="slider-container">
//                 {/* Current Image */}
//                 <div className="current-image-container">
//                     <img
//                         src={headerImages[currentImageIndex]}
//                         alt={`MAAK Development ${currentImageIndex + 1}`}
//                         className="current-image"
//                         style={{
//                             transform: `perspective(1000px) rotateY(${(mousePosition.x - 0.5) * 10}deg) rotateX(${(mousePosition.y - 0.5) * 10}deg) scale(1.1)`
//                         }}
//                     />

//                     {/* Hero Text Overlay */}
//                     <HeroTextOverlay />

//                     {/* 3D Parallax Elements */}
//                     <div className="parallax-elements">
//                         <div className="floating-element element-1"></div>
//                         <div className="floating-element element-2"></div>
//                         <div className="floating-element element-3"></div>
//                     </div>
//                 </div>
//             </div>

//             {/* Preload Next Images */}
//             <div className="preload-images" style={{ display: 'none' }}>
//                 {headerImages.map((image, index) => (
//                     <img key={index} src={image} alt="" />
//                 ))}
//             </div>
//         </section>
//     );
// };

// export default FullWidth3DSlider; 


























import React, { useState, useEffect, useRef } from "react";
import './FullWidth3DSlider.css';

const FullWidth3DSlider = ({ images }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const videoRef = useRef(null);

    // Hooks must always be called
    useEffect(() => {
        if (!images || images.length === 0) return; // safe check inside effect
        const interval = setInterval(() => {
            setCurrentImageIndex(prevIndex =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);
        return () => clearInterval(interval);
    }, [images]);

    const handleMouseMove = (e) => {
        if (videoRef.current) {
            const rect = videoRef.current.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width;
            const y = (e.clientY - rect.top) / rect.height;
            // Optional: Add subtle parallax effect to video
        }
    };

    if (!images || images.length === 0) return null; // safe to keep in render

    return (
        <section
            className="full-width-3d-slider video-hero"
            onMouseMove={handleMouseMove}
        >
            {/* Video Background */}
            <div className="video-background">
                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="hero-video"
                >
                    {/* <source src={heroVideo} type="video/mp4" /> */}
                    Your browser does not support the video tag.
                </video>
                {/* Video Overlay for better text readability */}
                <div className="video-overlay"></div>
            </div>

            {/* Main Slider Container */}
            <div className="slider-container">
                <div className="current-image-container">
                    <img
                        src={images[currentImageIndex]}
                        alt={`Slide ${currentImageIndex + 1}`}
                        className="current-image"
                        style={{
                            transform: `perspective(1000px) rotateY(${(mousePosition.x - 0.5) * 10}deg) rotateX(${(mousePosition.y - 0.5) * 10}deg) scale(1.1)`
                        }}
                    />

                    {/* 3D Parallax Elements */}
                    <div className="parallax-elements">
                        <div className="floating-element element-1"></div>
                        <div className="floating-element element-2"></div>
                        <div className="floating-element element-3"></div>
                    </div>
                </div>
            </div>

            {/* Preload Next Images */}
            <div className="preload-images" style={{ display: 'none' }}>
                {images.map((img, idx) => (
                    <img key={idx} src={img} alt="" />
                ))}
            </div>
        </section>
    );
};

export default FullWidth3DSlider;
